'use client';

import React, { useState } from 'react';
import Icon from '../Icon';

function StarRatingSecondary(props) {
  const {
    className,
    count,
    value,
    color = '',
    hoverColor = '#FFB131',
    activeColor = '#FFB131',
    size = 30,
    edit = false,
    isHalf = true,
    onChange,
  } = props;
  const emptyIcon = (
    <Icon
      type="star-gold-outline"
      width={size}
      height={size}
      color={color}
      className="w-[13px] lg:w-[25px] h-[12px] lg:h-[24px]"
    />
  );

  const halfIcon = (
    <Icon
      type="star-gold-outline-half-fill"
      width={size}
      height={size}
      color={color}
      className="w-[13px] lg:w-[25px] h-[12px] lg:h-[24px]"
    />
  );

  const fullIcon = (
    <Icon
      type="star-gold-outline-fill"
      width={size}
      height={size}
      color={color}
      className="w-[13px] lg:w-[25px] h-[13px] lg:h-[24px]"
    />
  );

  const [hoverValue, setHoverValue] = useState(undefined);
  const handleMouseMove = (index) => {
    if (!edit) {
      return;
    }
    setHoverValue(index);
  };

  const handleMouseLeave = () => {
    if (!edit) {
      return;
    }
    setHoverValue(undefined);
  };

  const handleClick = (index) => {
    if (!edit) {
      return;
    }
    if (onChange) {
      onChange(index + 1);
    }
  };

  const getColor = (index) => {
    if (hoverValue !== undefined) {
      if (index <= hoverValue) {
        return hoverColor;
      }
    }
    if (value > index) {
      return activeColor;
    }
    return color;
  };

  const stars = [];

  for (let i = 0; i < count; i += 1) {
    let star;
    if (isHalf && value - i > 0 && value - i < 1) {
      star = halfIcon;
    } else if (i < value) {
      star = fullIcon;
    } else {
      star = emptyIcon;
    }

    if (hoverValue !== undefined) {
      if (i <= hoverValue) {
        star = fullIcon;
      }
    }

    stars.push(
      <div
        role="presentation"
        key={i}
        style={{ cursor: 'pointer' }}
        onMouseMove={() => handleMouseMove(i)}
        onMouseLeave={handleMouseLeave}
        onClick={() => handleClick(i)}
      >
        {React.cloneElement(star, {
          size,
          color: getColor(i),
        })}
      </div>,
    );
  }

  return <div className={`rating ${className}`}>{stars}</div>;
}

export default StarRatingSecondary;
